
import {Component, Vue} from 'vue-property-decorator';
import HomeSidebarAds from "@/views/HomeSidebarAds.vue";

@Component({
  components: {HomeSidebarAds}
})
export default class Home2 extends Vue {
  public mounted() {
    window.onhashchange = () => {
      const id = location.hash.startsWith("#") ? location.hash.substring(1) : "top";
      document.getElementById(id).scrollIntoView()
    };

  }
}
